import { auth } from './firebase';

const FUNCTIONS_BASE_URL =
  process.env.REACT_APP_FUNCTIONS_BASE_URL || 'https://australia-southeast1-the-hub-crookwell.cloudfunctions.net';

const post = async (endpoint, body, requireAuth = false) => {
  const headers = { 'Content-Type': 'application/json' };
  if (requireAuth && auth.currentUser) {
    headers['Authorization'] = `Bearer ${await auth.currentUser.getIdToken()}`;
  }
  const res = await fetch(`${FUNCTIONS_BASE_URL}/${endpoint}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`SMS request failed: ${res.status}`);
  return res.json();
};

/** Send booking confirmation SMS */
export const sendBookingSms = ({ to, name, spaceName, startDate, endDate, bookingId }) =>
  post('sendBookingSms', { to, name, spaceName, startDate, endDate, bookingId });

/** Send payment link SMS */
export const sendPaymentLinkSms = ({ to, name, spaceName, startDate, price, payUrl }) =>
  post('sendPaymentLinkSms', { to, name, spaceName, startDate, price, payUrl });

/** Send a freeform admin SMS to a member */
export const sendAdminSms = ({ to, message }) =>
  post('sendAdminSms', { to, message });

/** Send a 6-digit OTP to verify a phone number change */
export const sendPhoneOtp = ({ uid, phone }) =>
  post('sendPhoneOtp', { uid, phone }, true);

/** Verify OTP code and update phone in Firestore */
export const verifyPhoneOtp = ({ token, code }) =>
  post('verifyPhoneOtp', { token, code }, true);
